import React, { useState } from 'react';
import { TemplateEditor, TemplateEditorConfig } from '../components/TemplateEditor';

// Test component to verify the reusable TemplateEditor works correctly
export const TemplateEditorTest: React.FC = () => {
  const [currentConfig, setCurrentConfig] = useState<TemplateEditorConfig>({
    showToolbar: true,
    showSidebar: true,
    enableExport: true,
    exportFormats: ['html', 'pdf', 'json'],
    enableRichTextFormatting: true,
    enableBackgroundCustomization: true,
  });

  const [editorData, setEditorData] = useState<any>(null);
  const [selectedBlock, setSelectedBlock] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<string>('page-1');

  const handleConfigChange = (key: keyof TemplateEditorConfig, value: any) => {
    setCurrentConfig(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSave = (data: any) => {
    console.log('✅ Template saved successfully:', data);
    alert('Template saved successfully!');
  };

  const handleExport = (data: any, format: string) => {
    console.log('✅ Template exported successfully:', { format, data });
    alert(`Template exported as ${format.toUpperCase()} successfully!`);
  };

  const handleChange = (data: any) => {
    setEditorData(data);
    console.log('📝 Template data changed:', data);
  };

  const handleBlockSelect = (blockId: string | null) => {
    setSelectedBlock(blockId);
    console.log('🎯 Block selected:', blockId);
  };

  const handlePageChange = (pageId: string) => {
    setCurrentPage(pageId);
    console.log('📄 Page changed:', pageId);
  };

  return (
    <div className="w-full h-screen bg-gray-50">
      {/* Test Controls */}
      <div className="bg-white border-b border-gray-200 p-4">
        <h1 className="text-xl font-bold mb-4">🧪 Template Editor Test Suite</h1>
        
        <div className="grid grid-cols-4 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium mb-1">Show Toolbar</label>
            <input
              type="checkbox"
              checked={currentConfig.showToolbar ?? true}
              onChange={(e) => handleConfigChange('showToolbar', e.target.checked)}
              className="rounded"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">Show Sidebar</label>
            <input
              type="checkbox"
              checked={currentConfig.showSidebar ?? true}
              onChange={(e) => handleConfigChange('showSidebar', e.target.checked)}
              className="rounded"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">Enable Export</label>
            <input
              type="checkbox"
              checked={currentConfig.enableExport ?? true}
              onChange={(e) => handleConfigChange('enableExport', e.target.checked)}
              className="rounded"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium mb-1">Rich Text</label>
            <input
              type="checkbox"
              checked={currentConfig.enableRichTextFormatting ?? true}
              onChange={(e) => handleConfigChange('enableRichTextFormatting', e.target.checked)}
              className="rounded"
            />
          </div>
        </div>

        <div className="flex gap-4 text-sm">
          <div>
            <strong>Selected Block:</strong> {selectedBlock || 'None'}
          </div>
          <div>
            <strong>Current Page:</strong> {currentPage}
          </div>
          <div>
            <strong>Total Pages:</strong> {editorData?.pages?.length || 0}
          </div>
          <div>
            <strong>Total Blocks:</strong> {editorData?.pages?.reduce((acc: number, page: any) => acc + (page.blocks?.length || 0), 0) || 0}
          </div>
        </div>
      </div>

      {/* Template Editor */}
      <div className="flex-1" style={{ height: 'calc(100vh - 120px)' }}>
        <TemplateEditor
          config={currentConfig}
          onChange={handleChange}
          onSave={handleSave}
          onExport={handleExport}
          onBlockSelect={handleBlockSelect}
          onPageChange={handlePageChange}
          className="w-full h-full"
        />
      </div>
    </div>
  );
};

export default TemplateEditorTest;
